<template>
  <Layout :footer-style="2">
    <div class="successDetail" id="successDetail">
      <div class="InformationDetails_content">
        <StaticBanner :banner-date="bannerDate"></StaticBanner>
        <div class="content_body container">
          <div class="card_data">
            <div class="card_data_tit">来源：博信诚云</div>
            <div>发布时间：2022-10-10</div>
          </div>
          <div class="main_card">
            <div class="left_main" id="left_main" v-for="(item, index) in htmlData" :key="index">
              <div class="left_card">
                <div class="logoImg">
                  <img class="logoImg2" :src="item.img1" alt="" />
                </div>
                <!-- <div class="logoImg1" :style="'background-image:'+item.img1"></div> -->
                <div class="fs-1 w-700 title-one">背景介绍</div>
                <div class="bar"></div>
                <p v-for="word in item.bgInformations">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ word.bgInformation }}
                </p>
                <div class="fs-1 w-700 title-one">应用模块</div>
                <div class="bar"></div>
                <div class="moudel" v-for="word in item.moudel">{{ word.moudel1 }}</div>
                <div class="fs-1 w-700 title-one">解决方案</div>
                <div class="bar"></div>
                <div class="left-img">
                  <img :src="item.img2" />
                </div>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.Solution }}</p>
                <div class="fs-1 w-700 title-one">应用亮点</div>
                <div class="bar"></div>
                <div class="Highlights" v-for="word in item.Highlights">
                  <div>{{ word.Highlights1 }}</div>
                  <div>{{ word.Highlights2 }}</div>
                </div>
                <div class="left-btn">
                  <button type="button" class="btn btn-outline-primary text-white backInformation"
                    @click="successCases('join')">
                    立即咨询
                  </button>
                  <button type="button" class="btn btn-outline-primary text-primary backInformation"
                    @click="successCases('back')">
                    返回列表
                  </button>
                </div>
              </div>
              <div class="bgGray"></div>
              <div class="main-bottom">
                <div class="bottom-news">
                  <div class="pravCases" @click="textDataPrav()">
                    <span class="w-600">上一页：</span>{{ item.prav }}
                  </div>
                  <div class="nextCases" @click="textDataNext()">
                    <span class="w-600">下一页：</span>{{ item.next }}
                  </div>
                </div>
              </div>
            </div>
            <div class="right_card" id="right_card" v-if="windowWidth>676">
              <div class="right_card_title w-700">博信诚，领先的智慧企业云平台服务商</div>
              <swiper class="mySwipes" :options="swiperOption" ref="DetailSwipe">
                <swiper-slide v-for="(item, index) in demoPages" :key="index">
                  <div class="Swipe_div" id="Swipe_div">
                    <router-link :to="item.url">
                      <img class="SwipeImg" :src="item.image" />
                      <li class="text-center">
                        <p class="w-700" style="margin: 0">{{ item.title }}</p>
                        <p style="height: 50px; overflow: hidden">{{ item.content }}</p>
                      </li>
                    </router-link>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="right_card" id="right_card" v-else>
              <div class="right_card_title w-700">博信诚，领先的智慧企业云平台服务商</div>
              <swiper class="mySwipes" :options="swiperOptions" ref="DetailSwipe">
                <swiper-slide v-for="(item, index) in demoPages" :key="index">
                  <div class="Swipe_div" id="Swipe_div">
                    <router-link :to="item.url">
                      <img class="SwipeImg" :src="item.image" />
                      <li class="text-center">
                        <p class="w-700" style="margin: 0">{{ item.title }}</p>
                        <p style="height: 50px; overflow: hidden">{{ item.content }}</p>
                      </li>
                    </router-link>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <div class="bottom_card">
          <div class="container">
            <div class="text-center bottom-one">
              <div class="fs-1 w-700">相关产品</div>
              <div class="fs-3">业财融合共享数字化专家</div>
            </div>
            <div class="bottom-list" v-if="windowWidth>767">
              <div class="col-lg-4 col-12" v-for="(item, index) in moreproductData[type - 1]" :key="index">
                <div class="moreBox">
                  <img class="moreBoxImg1" :src="item.img" alt="">
                  <img class="moreBoxImg2" src="@/assets/images/industry/bankground.png" alt="">
                  <div class="moreBoxContent">
                    <h5>{{ item.title }}</h5>
                    <button type="button" class="btn btn-outline-primary text-white liaojieallborder" @click="toDetails(item)">查看详情</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom-listes" v-else>
              <swiper class="mySwipes" :options="swiperOptiones">
                <swiper-slide v-for="(item, index) in moreproductData[type - 1]" :key="index">
                  <div class="moreBox">
                    <img class="moreBoxImg1" :src="item.img" alt="">
                    <img class="moreBoxImg2" src="@/assets/images/industry/bankground.png" alt="">
                    <div class="moreBoxContent">
                      <h5>{{ item.title }}</h5>
                      <button type="button" class="btn btn-outline-primary text-white liaojieallborder" @click="toDetails(item)">查看详情</button>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
body {
  overflow: visible !important;
}
</style>
<style lang="scss">
.successDetail {
  margin: 0 auto;
  max-width: 1920px;
  
  .InformationDetails_content {
    margin-top: 80px;
    background: #f7f7f7;

    .content_body {
      margin-top: -100px;

      .card_data {
        display: flex;
        position: relative;
        color: white;
        margin-bottom: 30px;
        padding: 0 20px;

        .card_data_tit {
          margin-right: 30px;
        }
      }

      .main_card {
        display: flex;
        justify-content: space-between;
        position: relative;
        padding-bottom: 3rem;

        &::after {
          content: "";
          display: block;
          overflow: hidden;
          clear: both;
        }

        .left_main {
          background: white;
          width: 70%;
          float: left;

          .left_card {
            padding: 30px 20px;
            .logoImg{
              height: 70px;
              .logoImg2{
                max-height: 70px;
              }
            }

            .logoImg1{
              background-repeat: no-repeat;
              background-position: center;
              height: 200px;
            }
          }

          .bar {
            background-color: #005bab;
            width: 24px;
            height: 5px;
            margin: 1rem 0;
          }

          .moudel,
          .Highlights {
            margin-bottom: 20px;
          }

          .left-img {
            margin-bottom: 20px;
            text-align: center;
          }

          .left-btn {
            display: flex;

            .backInformation {
              width: 12rem;
              height: 4rem;
              margin-right: 1rem;

              &:hover {
                background: #fff;
              }

              &:first-child {
                background: #005bab;
              }
            }
          }

          .bgGray {
            width: 200%;
            height: 4rem;
            margin-left: -50%;
            background: #f7f7f7;
          }

          .main-bottom {
            border-top: 2px solid #005bab;

            .bottom-news {
              padding: 1rem;

              .pravCases,
              .nextCases {
                cursor: pointer;

                &:hover {
                  color: #059dff;
                }
              }
            }
          }
        }

        .right_card {
          max-width: 400px;
          background: white;
          padding: 15px;

          width: 25%;
          height: 670px;
          padding-bottom: 70px;
          position: sticky;
          top: 80px;
          float: right;

          .right_card_title {
            height: 70px;
          }

          .right_card_list {
            a {
              &:hover {
                p {
                  color: #059dff;
                }
              }
            }
          }

          .Swipe_div {
            a {
              display: flex;
              justify-content: center;
              flex-wrap: wrap;
              height: 150px;
            }
          }

          .SwipeImg {
            width: 80%;
            height: 80%;
          }
        }
      }
    }

    .bottom_card {
      background: #fff;

      .bottom-list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .moreBox {
          position: relative;
          transition: all 1s ease;
          margin: 2rem 10px;
          &:hover {
            transform: scale(1.05);
        
            .moreBoxImg2 {
              opacity: 0.7;
            }
        
            .moreBoxContent {
              top: 6rem;
            }
        
            .liaojieallborder {
              opacity: 1 !important;
            }
          }
          .moreBoxImg2 {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            transition: all 1s linear;
          }
        
          .moreBoxContent {
            position: absolute;
            top: 10rem;
            left: 0rem;
            display: flex;
            padding: 0 5rem;
            width: 100%;
            flex-direction: column;
            align-items: center;
            transition: all 1s ease;
        
            h5 {
              color: white;
              text-align: center;
            }
        
            button {
              margin: 0;
            }
        
            .liaojieallborder {
              opacity: 0;
              transition: all 1s ease;
            }
          }
        }
        /*.list-one {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          .list-hover {
            position: relative;

            ._list_one {
              position: relative;
              text-align: center;

              .list-text {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);

                .bottom_list_title {
                  transition: all 0.5s linear;
                }

                .list-btn {
                  border: 1px solid #fff;
                  transition: opacity 0.5s linear;
                  opacity: 0;
                }
              }

              &:hover {
                .bottom_list_title {
                  transform: translateY(-20px);
                }

                .list-btn {
                  opacity: 1;
                }
              }
            }
          }
        }*/
      }
      .bottom-listes {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .moreBox {
          position: relative;
          transition: all 1s ease;
          margin: 2rem 10px;
          .moreBoxImg2 {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0.3;
            transition: all 1s linear;
          }
          .moreBoxContent {
            position: absolute;
            top: 6rem;
            left: 0rem;
            display: flex;
            padding: 0 5rem;
            width: 100%;
            flex-direction: column;
            align-items: center;
            transition: all 1s ease;
        
            h5 {
              color: white;
              text-align: center;
            }
        
            button {
              margin: 0;
            }
        
            .liaojieallborder {
              opacity: 1;
              transition: all 1s ease;
            }
          }
        }
      }
    }
  }
}
</style>
<script>
import Layout from "@/components/common/Layout"
import StaticBanner from "@/components/common/staticBanner/index.vue"
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
export default {
  components: { StaticBanner, Layout, swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        speed: 1000,
        direction: "vertical",
        slidesPerView: 3,
        loop: true,
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        // observer: true,
        // observeParents: true,
      },
      swiperOptions: {
        speed: 1000,
        slidesPerView: 2,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
      },
      swiperOptiones: {
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
      },
      moreproductData: [
        [
          {
            "img": require("@/assets/images/industry/moreproduct1.png"),
            "title": "ECOP云平台",
            "link": "/platform"
          },
          {
            "img": require("@/assets/images/industry/02-zhihuizhongtaiyun.png"),
            "title": "EEC-智慧财务共享（中台）云",
            "link": "/counter/2"
          },
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/02-zhihuizhongtaiyun.png"),
            "title": "EEC-智慧财务共享（中台）云",
            "link": "/counter/2"
          },
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/03-shuiwuguanliyun.png"),
            "title": "EEC-增值税管理云",
            "link": "/counter/3"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/05-zhihuiwnagyinyun.png"),
            "title": "EEC-智慧网银云",
            "link": "/counter/5"
          },
          {
            "img": require("@/assets/images/industry/moreproduct2-new.png"),
            "title": "ESC-智能合同管理平台",
            "link": "/portfolio/1"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/06-qmysgly.png"),
            "title": "EEC-全面预算云",
            "link": "/counter/6"
          },
          {
            "img": require("@/assets/images/industry/moreproduct2-new.png"),
            "title": "ESC-智能合同管理平台",
            "link": "/portfolio/1"
          },
          {
            "img": require("@/assets/images/industry/moreproduct3.png"),
            "title": "ESC-智慧业财平台",
            "link": "/portfolio/2"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/03-shuiwuguanliyun.png"),
            "title": "EEC-增值税管理云",
            "link": "/counter/3"
          },
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/moreproduct1.png"),
            "title": "ECOP云平台",
            "link": "/platform"
          }
        ],
        [
          {
            "img": require("@/assets/images/industry/moreproduct3.png"),
            "title": "ESC-智慧业财平台",
            "link": "/portfolio/2"
          },
          {
            "img": require("@/assets/images/industry/moreproduct1.png"),
            "title": "ECOP云平台",
            "link": "/platform"
          },
          {
            "img": require("@/assets/images/industry/06-qmysgly.png"),
            "title": "EEC-全面预算云",
            "link": "/counter/6"
          },
          
        ]
        ,
        [
          {
            "img": require("@/assets/images/industry/moreproduct1.png"),
            "title": "ECOP云平台",
            "link": "/platform"
          },
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/06-qmysgly.png"),
            "title": "EEC-全面预算云",
            "link": "/counter/6"
          }
        ],
        ,
        [
          {
            "img": require("@/assets/images/industry/01-zhihuiyecaiyitihuayun.png"),
            "title": "EEC-智慧业财一体化云",
            "link": "/counter/1"
          },
          {
            "img": require("@/assets/images/industry/03-shuiwuguanliyun.png"),
            "title": "EEC-增值税管理云",
            "link": "/counter/3"
          },
          {
            "img": require("@/assets/images/industry/06-qmysgly.png"),
            "title": "EEC-全面预算云",
            "link": "/counter/6"
          },
        ],
      ],
      bannerDate: {
        url: require("@/assets/images/aboutUs/InformationDetails-banner.png"),
        title: "博信诚荣获“2021中国企业上云数智化平台服务领军企业”",
        content: "",
        btn: false,
      },
      demoPages: [
        {
          url: "/success-detail/1",
          image: require("@/assets/images/casesimg/guolv-new.png"),
          imageLight: require("@/assets/images/casesimg/guolv-new.png"),
          title: "中国国旅",
          content: "全球化财务共享中心管理",
        },
        {
          url: "/success-detail/2",
          image: require("@/assets/images/casesimg/botian-new.png"),
          imageLight: require("@/assets/images/casesimg/botian-new.png"),
          title: "博天环境 ",
          content: "智慧业财新共享平台",
        },
        {
          url: "/success-detail/3",
          image: require("@/assets/images/casesimg/shanghai-baoye.png"),
          imageLight: require("@/assets/images/casesimg/shanghai-baoye.png"),
          title: "上海宝冶",
          content: "打造一流的最具竞争优势核心理念",
        },
        {
          url: "/success-detail/4",
          image: require("@/assets/images/casesimg/zhongliang.png"),
          imageLight: require("@/assets/images/casesimg/zhongliang.png"),
          title: "中梁控股集团",
          content: "支持中梁未来3000亿规模发展",
        },
        {
          url: "/success-detail/5",
          image: require("@/assets/images/casesimg/enfei-new.png"),
          imageLight: require("@/assets/images/casesimg/enfei-new.png"),
          title: "中国恩菲",
          content: "财务共享平台加速中国恩菲一路一带",
        },
        {
          url: "/success-detail/6",
          image: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          imageLight: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          title: "中冶置业",
          content: "地产企业业财融合智慧创新管理标杆",
        },
        {
          url: "/success-detail/7",
          image: require("@/assets/images/casesimg/jiaotong.png"),
          imageLight: require("@/assets/images/casesimg/jiaotong.png"),
          title: "中冶交通",
          content: "智能业财管理助力财务管控更高效",
        },
        {
          url: "/success-detail/8",
          image: require("@/assets/images/casesimg/huaxiafenmo.png"),
          imageLight: require("@/assets/images/casesimg/huaxiafenmo.png"),
          title: "华夏粉末冶金",
          content: "业财一体化应用为制造企业转型升级赋能",
        },
        {
          url: "",
          image: require("@/assets/images/casesimg/weichuang-yiliao.png"),
          imageLight: require("@/assets/images/casesimg/weichuang-yiliao.png"),
          title: "微创医疗",
          content: "智慧业财一体化平台",
        },
        {
          url: "",
          image: require("@/assets/images/casesimg/lizhong.png"),
          imageLight: require("@/assets/images/casesimg/lizhong.png"),
          title: "立中集团",
          content: "智慧业财一体化平台",
        },
        {
          url: "",
          image: require("@/assets/images/casesimg/BOE.png"),
          imageLight: require("@/assets/images/casesimg/BOE.png"),
          title: "BOE",
          content: "智慧业财一体化平台",
        },
        {
          url: "",
          image: require("@/assets/images/casesimg/NBTM.png"),
          imageLight: require("@/assets/images/casesimg/NBTM.png"),
          title: "NBTM",
          content: "智慧业财一体化平台",
        },
      ],
      textData: require("@/assets/JsonData/successDetail.json"),
      htmlData: "",
      type: "",
      imgs: [
        {
          img1: require('@/assets/images/home/anli/guolv.png'),
          img2: require('@/assets/images/casesimg/detail/guolv.png')
        },
        {
          img1: require('@/assets/images/home/anli/botian.png'),
          img2: require('@/assets/images/casesimg/detail/botian.png')
        },
        {
          img1: require('@/assets/images/home/anli/baoye.png'),
          img2: require('@/assets/images/casesimg/detail/baoye.png')
        },
        {
          img1: require('@/assets/images/home/anli/zl2.png'),
          img2: require('@/assets/images/casesimg/detail/zhongliang.png')
        },
        {
          img1: require('@/assets/images/home/anli/enf.png'),
          img2: require('@/assets/images/casesimg/detail/enfei.png')
        },
        {
          img1: require('@/assets/images/home/anli/zhiye2.png'),
          img2: require('@/assets/images/casesimg/detail/zhiye.png')
        },
        {
          img1: require('@/assets/images/home/anli/zhongyejiaotong.png'),
          img2: require('@/assets/images/casesimg/detail/jiaotong.png')
        },
        {
          img1: require('@/assets/images/home/anli/huaxiafenmo2.png'),
          img2: require('@/assets/images/casesimg/detail/huaxiafenmo.png')
        },
      ],
      swiperRef: '',
      windowWidth : document.documentElement.clientWidth,
    }
  },
  watch:{
    $route(){
      this.showData()
    }
  },
  mounted() {
    this.showData()

  },
  methods: {
    showData() {
      this.type = this.$route.params.type
      this.textData[this.type - 1].map((val, index) => {
        val.img1 = this.imgs[this.type - 1].img1
        val.img2 = this.imgs[this.type - 1].img2
      })
      this.bannerDate.title = this.textData[this.type - 1][0].title
      this.htmlData = this.textData[this.type - 1]
    },
    successCases(type) {
      if (type == "back") {
        this.$router.push({
          path: "/success-cases",
        })
      }
      if (type == "join") {
        this.$router.push({
          path: "/join-partners",
        })
      }
    },
    textDataPrav() {
      if (this.type == 1) {
        this.type = this.textData.length
      } else {
        this.type = this.type - 1
      }
      this.$router.push({
        path: "/success-detail/" + this.type,
      })
      this.htmlData = this.textData[this.type - 1]
    },
    textDataNext() {
      if (this.type == this.textData.length) {
        this.type = 1
      } else {
        this.type = Number(this.type) + 1
      }
      this.$router.push({
        path: "/success-detail/" + this.type,
      })
      this.htmlData = this.textData[this.type - 1]
    },
    toDetails(item){
      this.$router.push({
        path: item.link
      })
    },
  },
  destroyed() {
    let body = document.querySelector("body")
    body.style.overflow = "hidden"
  },
}
</script>
